import { Input } from '@prophecy/ui-v3/Input';
import { Select } from '@prophecy/ui-v3/Select';
import { Text } from '@prophecy/ui-v3/Typography';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
  width: 240px;
`;

export const StyledInput = styled(Input)`
  width: 360px;
`;

export const StyledMoreDetailsText = styled(Text)`
  text-decoration: underline;
`;
